import removeMd from 'remove-markdown'

export const extractPlainTextFromMarkdown = (markdown: string): string => {
  let plainText = removeMd(markdown, {
    stripListLeaders: true,
    gfm: true,
    useImgAltText: false
  })

  plainText = plainText.replace(/```[\w]*\n([\s\S]*?)```/g, (_match, code) => {
    return code.trim()
  })

  plainText = plainText.replace(/\$\$([\s\S]*?)\$\$/g, (_match, math) => {
    return math.trim()
  })
  plainText = plainText.replace(/\$([^$]+)\$/g, (_match, math) => {
    return math.trim()
  })

  plainText = plainText.replace(/\n\n+/g, '\n\n').trim()

  return plainText
}
